const minsAgo = (mins) => new Date() - (mins * 60_000);

export default minsAgo
